import "./Projects.css";
import ProjectCard from "./ProjectCard";
import { ProjectData } from "./ProjectData";

import { Carousel } from "primereact/carousel";
// import { Button } from "primereact/button";
// import { Tag } from "primereact/tag";

import { motion } from "framer-motion";
const Projects = () => {
  const responsiveOptions = [
    {
      breakpoint: "1199px",
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: "991px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "767px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  return (
    <div className="h-full bg-secondary-background-color" id="projects">
      <div className="flex justify-center h-[10%]">
        <motion.h3 animate={{ rotate: 360 }} className="section title">
          PROJECTS
        </motion.h3>
      </div>
      <div className="flex flex-wrap justify-center  items-center h-[90%] w-full ">
        <Carousel
          value={ProjectData}
          numVisible={3}
          numScroll={3}
          responsiveOptions={responsiveOptions}
          className="w-full h-full"
          circular
          autoplayInterval={5000}
          itemTemplate={ProjectCard}
        />
      </div>
    </div>
  );
};

export default Projects;
